// Overdressed 2026 — shortlist hearts (localStorage)
document.addEventListener('DOMContentLoaded', function () {
  var saved = [];
  try { saved = JSON.parse(localStorage.getItem('od-saved') || '[]'); } catch (e) {}
  document.querySelectorAll('.od-card__heart').forEach(function (b) {
    if (saved.indexOf(b.getAttribute('data-handle')) > -1) b.classList.add('saved');
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.od-card__heart');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-handle');
    var s = [];
    try { s = JSON.parse(localStorage.getItem('od-saved') || '[]'); } catch (err) {}
    if (s.indexOf(h) > -1) { s = s.filter(function (x) { return x !== h; }); b.classList.remove('saved'); }
    else { s.push(h); b.classList.add('saved'); }
    localStorage.setItem('od-saved', JSON.stringify(s));
  });
});

// Close the mobile menu drawer when tapping the scrim / outside it (or pressing Escape).
document.addEventListener('click', function (e) {
  var burger = document.querySelector('.od-burger[open]');
  if (!burger) return;
  if (e.target.closest('.od-drawer') || e.target.closest('.od-burger summary')) return;
  burger.removeAttribute('open');
});
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var burger = document.querySelector('.od-burger[open]');
  if (burger) burger.removeAttribute('open');
});

// ---- Slide-out cart drawer ----
(function () {
  var CFG = window.OD_CART || {};
  var GIFT = parseInt(CFG.giftId, 10) || 0;
  var TH = CFG.threshold || 0;
  var drawer = document.getElementById('od-cartd');
  if (!drawer) return;
  var body = document.getElementById('od-cartd-body');
  var foot = document.getElementById('od-cartd-foot');

  function money(p) { return '£' + (p / 100).toFixed(2); }
  function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(url, data) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) }).then(function (r) { return r.json(); }); }

  function open() { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function close() { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }

  // Keep the £55 free gift in sync (add at threshold, remove below). Uses line key for removal.
  function syncGift(cart) {
    if (!GIFT) return Promise.resolve(cart);
    var gift = null;
    for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].variant_id === GIFT) { gift = cart.items[i]; break; } }
    // Base the gift on the items' value (before order/shipping code discounts)
    // so applying a discount code can't strip the gift you've already earned.
    var spend = cart.items.reduce(function(sum, item) { return item.variant_id === GIFT ? sum : sum + item.final_line_price; }, 0);
    if (spend >= TH && !gift) { return post('/cart/add.js', { id: GIFT, quantity: 1 }).then(getCart); }
    if (spend < TH && gift) { return post('/cart/change.js', { id: gift.key, quantity: 0 }).then(getCart); }
    return Promise.resolve(cart);
  }

  function updateCount(cart) {
    var el = document.getElementById('od-cart-count');
    if (!el) return;
    if (cart.item_count > 0) { el.textContent = cart.item_count; el.removeAttribute('hidden'); }
    else { el.setAttribute('hidden', ''); }
  }

  // Free shipping / free gift progress bar (mirrors the cart page).
  function goalsHTML(cart) {
    var ship = CFG.shipGoal || 0;
    var gift = TH || 0;
    if (!ship && !gift) return '';
    var top = gift || ship;
    var spend = cart.items_subtotal_price;
    var msg;
    if (gift && spend >= gift) { msg = 'You’ve unlocked free shipping + your free gift ❆'; }
    else if (ship && spend >= ship) { msg = 'You’re ' + money(gift - spend) + ' away from ' + esc(CFG.giftLabel || 'a free gift'); }
    else { msg = 'You’re ' + money(ship - spend) + ' away from free UK shipping'; }
    // Not to scale: free-shipping bubble sits at the midpoint, free gift at the end.
    var hasGift = !!gift;
    var shipMark = hasGift ? 50 : 100;
    var pct;
    if (hasGift && spend >= gift) { pct = 100; }
    else if (ship && spend >= ship) { pct = shipMark + (hasGift && gift > ship ? Math.round((spend - ship) * (100 - shipMark) / (gift - ship)) : 0); }
    else if (ship) { pct = Math.round(spend * shipMark / ship); }
    else { pct = Math.round(spend * 100 / top); }
    pct = Math.max(0, Math.min(100, pct));
    var truck = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
    var giftIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
    return '<div class="od-goals">' +
      '<p class="msg' + (gift && spend >= gift ? ' ok' : '') + '">' + msg + '</p>' +
      '<div class="track"><div class="fill" style="width:' + pct + '%"></div>' +
        '<span class="mk ' + (spend >= ship ? 'on' : '') + '" style="left:' + shipMark + '%">' + truck + '</span>' +
        '<span class="mk ' + (spend >= gift ? 'on' : '') + '" style="left:100%">' + giftIcon + '</span>' +
      '</div>' +
      '<div class="marks">' +
        '<span class="' + (spend >= ship ? 'on' : '') + '" style="left:' + shipMark + '%">Free shipping</span>' +
        '<span class="' + (spend >= gift ? 'on' : '') + '" style="left:100%">Free gift</span>' +
      '</div></div>';
  }

  var discountMsg = '';
  function discountHTML(cart) {
    // Show every applied code (incl. free shipping), not just order-level ones.
    var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
    var amt = {};
    (cart.cart_level_discount_applications || []).forEach(function (a) { if (a.title) { amt[a.title.toUpperCase()] = a.total_allocated_amount; } });
    var applied = codes.length
      ? '<div class="od-disc__applied">' + codes.map(function (c) {
          var v = amt[(c.code || '').toUpperCase()];
          return '<span>✓ ' + esc(c.code) + ' applied' + (v ? ' (−' + money(v) + ')' : '') + '</span>';
        }).join('') + '</div>'
      : '';
    var err = discountMsg ? '<p class="od-disc__err">' + esc(discountMsg) + '</p>' : '';
    return applied + err + '<form class="od-disc" data-od-discount novalidate>' +
      '<input type="text" name="discount" placeholder="Discount code" autocomplete="off" aria-label="Discount code">' +
      '<button type="submit">Apply</button></form>';
  }

  // "We think you'll love" — recommendations based on the first non-gift cart item.
  function upsellInto(container, cart, freeMode) {
    if (!container) return;
    var seed = null;
    for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].variant_id !== GIFT) { seed = cart.items[i]; break; } }
    if (!seed) { container.innerHTML = ''; return; }
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
    fetch('/recommendations/products.json?product_id=' + seed.product_id + '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = (d.products || []).filter(function (p) { return !inCart[p.id]; }).slice(0, 8);
        if (!ps.length) { container.innerHTML = ''; return; }
        container.innerHTML = '<div class="od-upsell__h">' + (freeMode ? 'Add one more & only pay for two 🎁' : 'We think you’ll love') + '</div><div class="od-upsell__row">' +
          ps.map(function (p) {
            var img = p.featured_image || (p.images && p.images[0]) || '';
            var price = p.variants && p.variants[0] ? p.variants[0].price : (p.price || 0);
            var vid = p.variants && p.variants[0] ? p.variants[0].id : 0;
            return '<div class="od-upsell__card">' +
              '<a href="/products/' + p.handle + '" class="od-upsell__img">' + (img ? '<img src="' + sized(img, 160) + '" alt="" loading="lazy">' : '') + '</a>' +
              '<div class="od-upsell__nm">' + esc(p.title) + '</div>' +
              '<div class="od-upsell__pr">' + money(price) + '</div>' +
              '<button type="button" class="od-upsell__add" data-vid="' + vid + '">Add</button></div>';
          }).join('') + '</div>';
      })
      .catch(function () { container.innerHTML = ''; });
  }

  function render(cart) {
    updateCount(cart);
    if (!cart.items.length) {
      body.innerHTML = '<p class="od-cartd__empty">Your bag is empty.</p>';
      foot.innerHTML = '<button type="button" class="od-btn od-btn--primary" data-cartd-close style="width:100%">Continue shopping</button>';
      return;
    }
    var items = cart.items.slice().sort(function (a, b) { return (a.variant_id === GIFT ? 0 : 1) - (b.variant_id === GIFT ? 0 : 1); });
    function lineImg(it, sz) { return it.image ? '<img class="od-cartd__zoom" src="' + sized(it.image, 120) + '" data-zoom="' + sized(it.image, 900) + '" alt="' + esc(it.product_title) + '" width="' + sz + '" height="' + sz + '">' : '<div class="od-cartd__noimg"></div>'; }
    function giftRow(it) {
      var was = CFG.giftWas ? '<s>' + money(CFG.giftWas) + '</s> ' : '';
      return '<div class="od-cartd__line od-cartd__line--gift">' + lineImg(it, 64) +
        '<div class="g"><div class="t">' + esc(it.product_title) + '</div>' +
        '<div class="r"><span class="tag">' + (TH ? 'Free gift · over £' + Math.round(TH / 100) : 'Free gift') + '</span><span class="p">' + was + '<strong class="free">FREE</strong></span></div></div>' +
        '<span class="x" aria-hidden="true" style="visibility:hidden">✕</span></div>';
    }
    function normalRow(it) {
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="v">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="od-cartd__line" data-key="' + it.key + '">' + lineImg(it, 64) +
        '<div class="g"><div class="t">' + esc(it.product_title) + '</div>' + variant +
        '<div class="r"><div class="q"><button type="button" data-dec aria-label="Decrease">–</button><span>' + it.quantity + '</span><button type="button" data-inc aria-label="Increase">+</button></div>' +
        '<span class="p">' + money(it.final_line_price) + '</span></div></div>' +
        '<button type="button" class="x" data-remove aria-label="Remove">✕</button></div>';
    }
    // A built necklace = all lines sharing a "Necklace" code: shown as one bundle
    // card with a single total, "Part of bundle" components, and one remove.
    function bundleRow(grp) {
      var total = grp.reduce(function (s, x) { return s + x.final_line_price; }, 0);
      var keys = grp.map(function (x) { return x.key; }).join(',');
      var parts = grp.map(function (x) {
        return '<div class="od-cartd__nk-item">' + lineImg(x, 44) +
          '<div class="g"><div class="t">' + esc(x.product_title) + '</div><span class="qf">Part of bundle</span></div></div>';
      }).join('');
      return '<div class="od-cartd__nk">' +
        '<div class="od-cartd__nk-bar"><span class="nk-t">Charm Necklace Bundle <span class="tag">Bundle</span></span>' +
        '<span class="p">' + money(total) + '</span>' +
        '<button type="button" class="x" data-remove-group="' + keys + '" aria-label="Remove necklace">✕</button></div>' +
        parts + '</div>';
    }
    var done = {};
    var rows = items.map(function (it) {
      if (it.variant_id === GIFT) return giftRow(it);
      var code = it.properties && it.properties.Necklace;
      if (code) {
        if (done[code]) return '';
        done[code] = 1;
        var grp = items.filter(function (x) { return x.variant_id !== GIFT && x.properties && x.properties.Necklace === code; });
        return bundleRow(grp);
      }
      return normalRow(it);
    }).join('');
    // Buy-2-Get-1 nudge: when one more standalone item completes a pay-for-2 trio.
    var eligibleQty = 0;
    items.forEach(function (it) {
      if (it.variant_id === GIFT) return;                     // free gift doesn't count
      if (it.properties && it.properties.Necklace) return;    // charm-bundle parts don't count
      eligibleQty += it.quantity;
    });
    var oneMoreFree = CFG.promo && eligibleQty === 2;
    var hasGift = items.some(function (it) { return it.variant_id === GIFT; });
    var nudge = '';
    if (oneMoreFree) {
      var nStrong = hasGift ? 'Add another piece — absolutely free 🎁' : 'You’re one piece away from a freebie 🎁';
      var nSpan = hasGift
        ? 'Your free gift’s already unlocked — add a third piece and you’ll still only pay for two.'
        : 'Add a third piece and you’ll only pay for two with Buy 2, Get 1 Free.';
      nudge = '<div class="od-cartd__nudge"><strong>' + nStrong + '</strong><span>' + nSpan + '</span></div>';
    }
    body.innerHTML = goalsHTML(cart) + nudge + rows + '<div class="od-upsell" id="od-cartd-upsell"></div>';
    // A code may discount the order or shipping; we can't compute the final
    // total here, so defer delivery + total to checkout when one is applied.
    var hasCode = (cart.discount_codes || []).some(function (d) { return d.applicable; });
    var shipCost = (CFG.shipGoal && cart.items_subtotal_price >= CFG.shipGoal) ? 0 : (CFG.shipRate || 0);
    var giftInCart = false, b2g1fSaved = 0;
    items.forEach(function (it) {
      if (it.variant_id === GIFT) {
        giftInCart = true;
      } else {
        b2g1fSaved += (it.original_line_price || 0) - (it.final_line_price || 0);
      }
    });
    var displayTotal = cart.total_price;
    var grandTotal = displayTotal + shipCost;
    foot.innerHTML = (CFG.discount === false ? '' : discountHTML(cart)) +
      (b2g1fSaved > 0 ? '<div class="od-cartd__sub od-cartd__saving"><span>Buy 2, Get 1 Free offer</span><span>−' + money(b2g1fSaved) + '</span></div>' : '') +
      (giftInCart ? '<div class="od-cartd__sub od-cartd__saving"><span>Free gift · over £' + Math.round(TH / 100) + '</span><span>FREE</span></div>' : '') +
      '<div class="od-cartd__sub"><span>Subtotal</span><strong>' + money(displayTotal) + '</strong></div>' +
      '<div class="od-cartd__sub od-cartd__ship"><span>Delivery <span class="note">(UK · rest at checkout)</span></span><span>' + (hasCode ? 'At checkout' : (shipCost === 0 ? 'Free' : money(shipCost))) + '</span></div>' +
      '<a href="/checkout" class="od-btn od-btn--primary" style="width:100%">' + (hasCode ? 'Checkout' : 'Checkout · ' + money(grandTotal)) + '</a>' +
      '<p class="od-cartd__trust">Excellent <span class="od-stars">★★★★★</span> from 10,000+ customers</p>';
    upsellInto(document.getElementById('od-cartd-upsell'), cart, oneMoreFree);
  }

  function refresh(openIt) {
    discountMsg = '';
    return getCart().then(syncGift).then(function (cart) { render(cart); if (openIt) open(); return cart; });
  }

  // qty / remove inside the drawer
  body.addEventListener('click', function (e) {
    // remove a whole necklace (all its component lines at once)
    var rg = e.target.closest('[data-remove-group]');
    if (rg) {
      var updates = {};
      rg.getAttribute('data-remove-group').split(',').forEach(function (k) { updates[k] = 0; });
      post('/cart/update.js', { updates: updates }).then(syncGift).then(render);
      return;
    }
    var line = e.target.closest('.od-cartd__line'); if (!line) return;
    var key = line.getAttribute('data-key'); if (!key) return;
    var span = line.querySelector('.q span');
    var qty = span ? parseInt(span.textContent, 10) : 1;
    var next = null;
    if (e.target.closest('[data-remove]')) next = 0;
    else if (e.target.closest('[data-dec]')) next = Math.max(0, qty - 1);
    else if (e.target.closest('[data-inc]')) next = qty + 1;
    if (next === null) return;
    post('/cart/change.js', { id: key, quantity: next }).then(syncGift).then(render);
  });

  // close: scrim click, close button, keep-shopping, Escape
  drawer.addEventListener('click', function (e) {
    if (e.target === drawer || e.target.closest('[data-cartd-close]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // Tap a line image (incl. the free gift) to zoom it in a lightbox.
  var zoom = document.createElement('div');
  zoom.className = 'od-zoom';
  zoom.setAttribute('aria-hidden', 'true');
  zoom.innerHTML = '<button type="button" class="od-zoom__close" aria-label="Close">&times;</button><img alt="">';
  document.body.appendChild(zoom);
  var zoomImg = zoom.querySelector('img');
  function openZoom(src, alt) { zoomImg.src = src; zoomImg.alt = alt || ''; zoom.classList.add('open'); zoom.setAttribute('aria-hidden', 'false'); }
  function closeZoom() { zoom.classList.remove('open'); zoom.setAttribute('aria-hidden', 'true'); zoomImg.removeAttribute('src'); }
  document.addEventListener('click', function (e) {
    var z = e.target.closest('.od-cartd__zoom');
    if (z && z.getAttribute('data-zoom')) { e.preventDefault(); openZoom(z.getAttribute('data-zoom'), z.getAttribute('alt')); return; }
    if (e.target === zoom || e.target.closest('.od-zoom__close')) closeZoom();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && zoom.classList.contains('open')) { e.stopPropagation(); closeZoom(); }
  }, true);

  // cart icon opens the drawer instead of navigating
  var cartLink = document.querySelector('.od-cart-link');
  if (cartLink) { cartLink.addEventListener('click', function (e) { e.preventDefault(); refresh(true); }); }

  // intercept the product add-to-cart form
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#od-pdp-form'); if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[name="add"]');
    if (btn) { btn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
      .then(function () { return refresh(true); })
      .then(function () { if (btn) { btn.disabled = false; } })
      .catch(function () { form.submit(); }); // fall back to normal redirect on error
  });

  // discount code: apply via Shopify's /discount endpoint, then re-render in place
  // (no full-page redirect). Handles free-shipping as well as amount/% codes.
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-od-discount]'); if (!f) return;
    e.preventDefault();
    var input = f.querySelector('input[name="discount"]');
    var code = (input && input.value || '').trim();
    if (!code) return;
    var inDrawer = !!e.target.closest('#od-cartd');
    var btn = f.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Applying…'; }
    fetch('/discount/' + encodeURIComponent(code), { headers: { Accept: 'text/html' } })
      .then(function () { return getCart(); })
      .then(function (cart) {
        var ok = (cart.discount_codes || []).some(function (d) { return (d.code || '').toUpperCase() === code.toUpperCase() && d.applicable; });
        if (!inDrawer) { window.location.reload(); return; }
        discountMsg = ok ? '' : 'Sorry, “' + code + '” isn’t valid for this order.';
        return syncGift(cart).then(render);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'Apply'; } });
  });

  // upsell "Add" — add the variant, then refresh the drawer (or reload the cart page)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.od-upsell__add'); if (!b) return;
    var vid = parseInt(b.getAttribute('data-vid'), 10); if (!vid) return;
    b.disabled = true; b.textContent = 'Adding…';
    post('/cart/add.js', { id: vid, quantity: 1 })
      .then(function () { if (e.target.closest('#od-cartd')) { return refresh(true); } location.reload(); })
      .catch(function () { b.disabled = false; b.textContent = 'Add'; });
  });

  // populate the upsell row on the full cart page (if present)
  var pageUpsell = document.getElementById('od-cart-upsell');
  if (pageUpsell) { getCart().then(function (cart) { upsellInto(pageUpsell, cart); }); }

  // let other scripts (e.g. Frequently Bought Together) reuse the drawer
  window.odCartOpen = function () { return refresh(true); };
})();